import React from 'react'
import { Icon } from '../../atoms'
import { getValue } from '../../utils/product-schema'
import { getMoreInformationContent } from './utils'

const MoreInformation = ({ type, content, title, product }) => {
  if (type === 'html') {
    return (
      content.some((c) => getValue(c, product)) && (
        <div className='ProductTable__moreInfo__block'>
          <div className='ProductTable__moreInfo__block__title'>{getValue(title, product)}</div>
          {content.map((c, index) => (
            <div
              key={index}
              className='ProductTable__moreInfo__block__description'
              dangerouslySetInnerHTML={{ __html: getValue(c, product) }}
            />
          ))}
        </div>
      )
    )
  } else if (type === 'list') {
    return (
      <div className='ProductTable__moreInfo__block'>
        <div className='ProductTable__moreInfo__block__title'>{getValue(title, product)}</div>
        <div className='ProductTable__moreInfo__block__description--list'>
          <table>
            <tbody>
              {content
                .filter(({ value }) => getValue(value, product))
                .map(({ label, value }, index) => {
                  const v = getValue(value, product)
                  return (
                    <tr key={index}>
                      <td>{getValue(label, product)}</td>
                      <td>{v === true ? <Icon glyph='tick-green' size={24} /> : v}</td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
      </div>
    )
  } else if (type === 'table' && getMoreInformationContent(content, product)) {
    return (
      <div className='ProductTable__moreInfo__block'>
        <div className='ProductTable__moreInfo__block__title'>{getValue(title, product)}</div>
        <div className='ProductTable__moreInfo__block__description--table'>
          <table>
            <tbody>
              {getMoreInformationContent(content, product).map((row, rowIndex) => {
                return (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => {
                      return cell.type === 'th' ? (
                        <th key={cellIndex} colSpan={cell.colspan}>
                          {cell.value}
                        </th>
                      ) : (
                        <td key={cellIndex} colSpan={cell.colspan}>
                          {cell.value}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  } else {
    return <div />
  }
}

export default MoreInformation
